// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileSearchOutlinedSvg from "@fishx/icons-svg/es/asn/PFileSearchOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileSearchOutlined = function PFileSearchOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileSearchOutlinedSvg
  }));
};

PFileSearchOutlined.displayName = 'PFileSearchOutlined';
export default React.forwardRef(PFileSearchOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileSearchOutlined.js
// module id = 3397
// module chunks = 0